// modules/inicio/api/authAPI.js
import axiosClient from "./axiosClient";

export async function loginAPI(identificacion, password) {
  const { data } = await axiosClient.post("/auth/login", { identificacion, password });
  return data; // { token, usuario }
}

// Registro público: crea la cuenta en estado "pendiente" — no puede iniciar
// sesión hasta que un administrador la apruebe.
// body: { nombre, identificacion, email, numero_contrato, password, programas }
export async function registroAPI(datos) {
  const { data } = await axiosClient.post("/auth/registro", datos);
  return data; // { mensaje }
}

export async function obtenerPerfilAPI() {
  const { data } = await axiosClient.get("/auth/yo");
  return data.usuario;
}

// Paso 1 de restablecer contraseña: verifica identificación + número de contrato.
export async function verificarIdentidadAPI(identificacion, numero_contrato) {
  const { data } = await axiosClient.post("/auth/verificar-identidad", {
    identificacion,
    numero_contrato,
  });
  return data; // { token, expira_en, mensaje }
}

// Paso 2: usa el token del paso 1 para fijar la nueva contraseña.
export async function restablecerPasswordAPI(token, nueva_password) {
  const { data } = await axiosClient.post("/auth/restablecer-password", {
    token,
    nueva_password,
  });
  return data; // { mensaje }
}
